<template>
	<div>
		<label class="radio-box" v-bind:class="{ 'active': isActive }" v-bind:for="labelFor">
			<div class="circle-container">
				<div class="circle" v-bind:style="`background-color: ${color}`">
					{{shortText}}
				</div>
			</div>
			<p>
				{{text}}
			</p>
			<input hidden v-bind:id="labelFor" type="radio" v-on:change="onChange" name="type" v-bind:value="value" />
		</label>
	</div>
</template>

<script>

function onChange() {
	this.$emit('change', this.value);
}

export default {
	name: 'radio-keeping',
	props: {
		color: {
			type: String,
			default: 'purple',
		},
		isActive: {
			type: Boolean,
			default: false,
		},
		labelFor: {
			type: [String, Number],
			required: true,
		},
		text: {
			type: String,
			required: true,
		},
		shortText: {
			type: String,
			required: true,
		},
		value: {
			type: [String, Number],
			required: true,
		},
	},
	methods: {
		onChange,
	},
};
</script>

<style lang="scss" scoped>
label.radio-box {
	background-color: white;
	box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.18);
	cursor: pointer;
	display: flex;
	height: 40px;
	margin-right: 20px;
	width: 100%;

	&.active {
		background-color: map-get($colors, default-skyblue);
		color: white;
		.circle-container {
			border-right: 1px solid rgba(0, 0, 0, 0.17);
		}
		p {
			font-family: map-get($fonts, bold);
		}
	}

	.circle-container {
		border-right: 1px solid map-get($colors, default-bg);
		display: flex;
		width: 43px;
	}

	.circle {
		background-color: map-get($colors, bg-mm);
		border-radius: 50%;
		color: white;
		font-family: map-get($fonts, bold);
		height: 23px;
		line-height: 23px;
		margin: auto;
		width: 23px;
	}

	p {
		font-family: map-get($fonts, light);
		margin: auto;
		text-align: center;
		width: 144px;
	}
}
</style>




// WEBPACK FOOTER //
// RadioKeeping.vue?3a6ec1d5